import React, { useMemo, } from "react";
import { DataGrid, Column } from "devextreme-react/data-grid";
import { useDataSource } from "../../../contexts/dataSource";
import { getPropsDataGrid } from "../../../utils/default-props";

interface UsedLeaveTabProps {
    employeeId: number;
    leaveInfoId: number;
}

const UsedLeaveTabComponent: React.FC<UsedLeaveTabProps> = ({ employeeId, leaveInfoId }) => {
    const { dataSourceHR } = useDataSource();

    const detailDataSource = useMemo(
        () =>
            dataSourceHR({
                loadUrl: `/api/EmployeeLeave/EmployeeWithLeaveInfoId/${employeeId}/${leaveInfoId}`,
            }),
        [dataSourceHR, employeeId, leaveInfoId]
    );

    return (
        <DataGrid dataSource={detailDataSource}  {...getPropsDataGrid}>
            <Column dataField="startDate" caption="İzin Başlangıç" dataType="date" format="shortDate" />
            <Column dataField="endDate" caption="İzin Bitiş" dataType="date" format="shortDate" />
            <Column dataField="duration" caption="Süre" alignment="center" />
        </DataGrid>
    );
};

export default UsedLeaveTabComponent;